import React from 'react';
import Button from './button';

export default function Secondary(props) {
  return <Button variant="secondary" {...props} />;
}
